(function ($) {

    $('.site-head__burger, .mobile-nav__close').on('click', function(event){

       event.preventDefault();
       
       if($('#mobile-nav').hasClass('is-active')){

           $('#mobile-nav').removeClass('is-active');
           $(this).removeClass('is-active');
           $('.site-head__logo--light').addClass('is-active');

       } else {

           $('#mobile-nav').addClass('is-active');
           $(this).addClass('is-active');
           $('.site-head__logo--light').removeClass('is-active');

       }

    });

}(jQuery));